import React from 'react';
import buildupStyles from './buildup.module.css';
import styles from '../../../../../custom/style.module.css';
import { Badge, Box, Button, Checkbox, Chip, Divider, FormControl, Grid, IconButton, InputAdornment, MenuItem, Popover, Radio, Stack, TextField, Typography } from '@mui/material';
import { CustomAutocomplete, CustomButton, CustomCheckbox, CustomFormHelperText, CustomInputLabel, CustomSelect, CustomTextField, DataGridProps, FlexDiv, InputProps, SelectInputProps, StyledCard, StyledCardTitle, StyledDataGrid, TableBadge } from 'custom/components';
import { AddIcon, ClearXIcon, CloseIconBtn, DateFormat, DeleteIcon, DocIcon, EditIcon, SaveTickIcon } from 'custom/constants';
import { Balance, Circle, FormatListBulleted, Forward, Refresh, Search } from '@mui/icons-material';
import AwbDetailModal from './AwbDetailsModal';
import History from 'components/pages/common/History';
import MoveUldToDiffFlight from './MoveUldToDiffFlight';
import cookies from 'utils/cookies';
import CommentIcon from '@mui/icons-material/Comment';
import Lock from '../../../../../assets/images/actionIcons/lock.svg';
import Unlock from '../../../../../assets/images/actionIcons/unlock.svg';
import Edit from '../../../../../assets/images/actionIcons/edit.svg';
import Status from './Status';
import { GridActionsCellItem, GridRowModes } from '@mui/x-data-grid';
import RemarkModal from 'components/pages/common/RemarkModal';
import TableWrapper from 'components/pages/common/TanStackTableWrapper';
import AwbInfoModal from './AwbInfoModal';
import moment from 'moment';

function PopoverActionCell({ row }) {
  let try_awb = row?.try_awb;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const screening = Array.isArray(try_awb?.screening) ? try_awb.screening[0] : try_awb?.screening;
  const screeningRows = screening ? [
    {
      label: 'Date',
      value: `${moment(screening?.date_time || '-').format(DateFormat).toUpperCase()} ${screening?.time || ''}`.trim()
    },
    {
      label: 'Flight Number',
      value: screening?.flight && screening?.flight.split(' ').join('').toUpperCase() || '-'
    },
    {
      label: 'Pieces',
      value: screening?.pieces ?? '-'
    },
    {
      label: 'Actual Weight',
      value: screening?.actual_weight ?? '-'
    },
    {
      label: 'Measure Applied',
      value: screening?.measure_applied || '-'
    },
    {
      label: 'Screened By',
      value: screening?.screened_by || '-'
    },
    {
      label: 'Screening Details',
      value: screening?.screening_details || '-'
    },
    {
      label: 'Details',
      value: screening?.details || '-'
    },
    {
      label: 'Alarm',
      value: screening?.alarm ? 'Yes' : 'No'
    },
    {
      label: 'Alarm Resolution',
      value: screening?.alarm_resolution || screening?.alarm_resoultion || '-'
    },
  ] : [];
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  return (
    <>
      <IconButton
        size='small'
        className={styles.p0}
        title='AWB Info'
        onClick={handleClick}
      >
        <code className={styles.infoIcon}> i </code>
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Box sx={{
          p: 2,
          minWidth: 280,
          maxWidth: 400,
        }}>
          <Typography variant='h6' component='h6' mb={2}
            sx={{
              backgroundColor: '#092b4a',
              color: 'white',
              padding: ' 6px  10px',
              marginInline: '-16px',
              marginTop: '-16px',
              fontWeight: 'bolder',
            }}>
            {try_awb?.number ? `${try_awb?.code}-${try_awb.number}` : ''}</Typography>
          {screeningRows.length > 0 && (
            <>
              <Typography variant='subtitle2' color='primary' mb={1}
                sx={{
                  backgroundColor: '#e8e8e8',
                  marginInline: '-16px',
                  paddingInline: '15px',
                  marginTop: '20px' 
                }}
              >Screening</Typography>
              <Grid container rowSpacing={0.5} columnSpacing={2}>
                {screeningRows.map((item) => (
                  <React.Fragment key={item.label}>
                    <Grid item xs={5}>
                      <Typography variant='caption' color='text.secondary'>
                        {item.label}
                      </Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography variant='body2' color='primary'>
                        {item.value || '-'}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                ))}
              </Grid>
            </>
          )}
        </Box>
      </Popover>
    </>
  );
}
const Buildup = (props) => {
  const CHARACTER_LIMIT = 150;
  const role = cookies.get('role');
  const canEditWgt = role === 'Supervisor' || role === 'System Admin' || role === 'Manager';
  console.log(role, canEditWgt);

  const uldListColumns = [
    {
      field: '',
      headerName: '',
      width: 30,
      minWidth: 30,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) => {
        return (
          <Radio size='small' className={styles.p0}
            checked={props.editUldFields?.id === row?.id}
          />
        );
      }
    },
    {
      field: 'uld_no',
      headerName: 'ULD ID',
      minWidth: 130,
      flex: 1,
      editable: true,
      cellClassName: buildupStyles.editCell
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: '',
      width: 40,
      minWidth: 30,
      getActions: ({ id }) => {
        const isInEditMode = props.editMode[id]?.mode === GridRowModes.Edit;
        if (isInEditMode) {
          return [
            <GridActionsCellItem
              key={'save'}
              icon={<SaveTickIcon />}
              label='Save'
              sx={{ color: 'primary.main' }}
              onClick={props.handleSaveClick(id)}
              disableRipple
            />,
            <GridActionsCellItem
              key={'cancel'}
              icon={<ClearXIcon title='Close' />}
              label='Cancel'
              className='textPrimary'
              onClick={props.handleCancelClick(id)}
              color='inherit'
            />,
          ];
        }
        return [
          <GridActionsCellItem
            key={'edit'}
            icon={<img src={Edit} alt='Edit' width={14} height={14} />}
            label='Edit'
            className='textPrimary'
            onClick={props.handleEditClick(id)}
            color='inherit'
            disableRipple
            disabled={Boolean(props.showReportModal) || props.isNoOp || cookies.get('role') === 'Airline Rep'}
            classes={{ disabled: styles.disabledImg }}
          />,

        ];
      },
    },
    {
      field: 'o_c',
      headerName: 'O/C',
      align: 'center',
      headerAlign: 'center',
      minWidth: 60,
      flex: 1,
      renderCell: ({ row }) => {
        return row.closed ? 'C' : 'O';
      }
    },
    {
      field: 'wgt',
      headerName: 'ULD wgt',
      minWidth: 100,
      flex: 1,
      renderCell: ({ row }) => {
        return (row?.wgt || (row?.scale_wgt || 0) - (row?.dolly_tare || 0)) + ' K';
      }
    },
    {
      field: 'mnfst_wgt',
      headerName: 'Mnfst wgt',
      minWidth: 100,
      flex: 1,
      renderCell: ({ row }) => {
        return (row?.buildup_awb?.reduce((acc, curr) => parseFloat(acc) + parseFloat(curr?.wgt || 0), 0) || 0) + ' K';
      }
    },
    {
      field: 'dev',
      headerName: 'Dev',
      minWidth: 100,
      flex: 1,
      renderCell: ({ row }) => {
        let wgt = row?.wgt || (row?.scale_wgt || 0) - (row?.dolly_tare || 0);
        let mnfst_wgt = row?.buildup_awb?.reduce((acc, curr) => parseFloat(acc) + parseFloat(curr?.wgt || 0), 0) || 0;
        if (wgt > 0) {
          return ((wgt - mnfst_wgt) / wgt * 100).toFixed(2) + '%';
        } else {
          return '0%';
        }
      }
    },
    {
      field: 'dest',
      headerName: 'ULD dest',
      minWidth: 100,
      flex: 1,
    },
    {
      field: 'contour',
      headerName: 'Cont',
      width: 80,
    },
    {
      field: 'remark',
      headerName: 'Remarks',
      width: 72,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) => {
        return (row?.remark ? <Badge color='secondary' variant='dot'>
          <IconButton
            onClick={() => props.handleOpen('remark', row?.remark)}
            className={`${styles.p0}`}
            size='small'
            color='primary'>
            <CommentIcon fontSize='inherit' />
          </IconButton>
        </Badge>
          : <IconButton
            className={`${styles.p0}`}
            size='small'
            disabled
          >
            <CommentIcon fontSize='inherit' />
          </IconButton>
        );
      }
    },
    {
      field: 'action',
      headerName: 'Action',
      headerAlign: 'center',
      align: 'center',
      width: 140,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) => {
        return (
          <Stack direction='row' spacing={1} justifyContent='center' className={styles.actionIcons}>
            <Button title='History' size='small' variant='outlined' className={buildupStyles.historyIcon} disableElevation
              onClick={(e) => props.handleOpen('history', e.currentTarget)}> H</Button>
            <Button title='Move ULD to different flight' size='small' variant='outlined' className={buildupStyles.historyIcon} disableElevation
              onClick={(e) => props.handleOpen('move_uld_to_diff_flight', e.currentTarget)}><Forward /></Button>
            <IconButton title='Download ULD PDF' size='small' className={styles.p0}
              onClick={() => props.handleUldPdf(row)}><DocIcon /></IconButton>
            <DeleteIcon title='Delete' onClick={(e) => props.handleDelete('uld', row.id, e.target)} disabled={props.showReportModal || props.isNoOp || cookies.get('role') === 'Airline Rep'} />
          </Stack>
        );
      }
    },
  ];


  const uldContentColumns = [
    {
      accessorKey: 'awb_no',
      header: 'AWB#',
      cell: ({ row }) => (
        <Stack direction='row' spacing={1} alignItems='center'>
          <Typography variant='inherit'>{row.original.awb_no}</Typography>
          <PopoverActionCell row={row.original} />
        </Stack>
      ),
    },
    {
      accessorKey: 'pcs',
      header: 'Pcs',
      cell: ({ row }) => (
        <Typography variant='inherit' className={buildupStyles.pcsCell}>
          {row.original.pcs}
        </Typography>
      ),
    },
    {
      accessorKey: 'wgt',
      header: 'Wgt',
      cell: ({ row }) => (
        <Typography variant='inherit' className={buildupStyles.pcsCell}>
          {(row.original.wgt || 0) + ' K'}
        </Typography>
      ),
    },
    {
      accessorKey: 'org_dest',
      header: 'Org-Dest',
      cell: ({ row }) => `${row.original.org}-${row.original.dest}`,
    },
    {
      accessorKey: 'spl_code',
      header: 'SPLs',
      cell: ({ row }) => <span className={buildupStyles.ULDSplCode}>{row.original.spl_code?.split(',').join(', ')}</span>,
    },
    {
      accessorKey: 'remark',
      header: 'Remarks',
      cell: ({ row }) =>
        row.original?.remark ? (
          <Badge color='secondary' variant='dot'>
            <IconButton
              onClick={() => props.handleOpen('remark', row.original?.remark)}
              className={styles.p0}
              size='small'
              color='primary'
            >
              <CommentIcon fontSize='inherit' />
            </IconButton>
          </Badge>
        ) : (
          <IconButton className={styles.p0} size='small' disabled>
            <CommentIcon fontSize='inherit' />
          </IconButton>
        ),
    },
    {
      accessorKey: 'action',
      header: 'Action',
      enableSorting: false,
      enableColumnFilter: false,
      cell: ({ row }) => (
        <Stack direction='row' spacing={1} justifyContent='center' className={styles.actionIcons}>
          <EditIcon
            disabled={props.editUldFields.closed || props.showReportModal}
            onClick={() => props.onSearch(row.original.awb_no)}
          />
          <DeleteIcon
            disabled={props.editUldFields.closed || props.showReportModal}
            onClick={(e) => props.handleDelete('awb', row.original.id, e.target)}
          />
        </Stack>
      ),
    },
  ];

  return (
    <>
      <Grid container spacing={3} sx={{ marginTop: props.showRejectedMessage || props.showNilMessage ? '-24px' : '-48px' }}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={7}>
          <StyledCard className={styles.h100}>
            <FlexDiv><StyledCardTitle >ULD List </StyledCardTitle></FlexDiv>
            <Stack direction='row' spacing={1} alignItems='center' justifyContent='flex-end' mb={2} mt={'-16px'}>
              <CustomTextField
                {...InputProps}
                id='uld_id'
                placeholder='Enter ULD ID'
                type='text'
                name='uld_no'
                onChange={props.onChangeAddUld}
                value={props.addUldFields.uld_no || ''}
                className={`${styles.brInput}`}
                disabled={Boolean(props.showReportModal) || props.isNoOp || cookies.get('role') === 'Airline Rep'}
              // InputProps={{
              //   disableUnderline: true,
              //   endAdornment: <InputAdornment position='end'>
              //     <IconButton
              //       size='large'
              //       aria-label='search'
              //       onClick={props.onAddUld}
              //       edge='end'
              //       disableRipple
              //       color='primary'
              //     >
              //       <AddCircle fontSize='inherit' />
              //     </IconButton>
              //   </InputAdornment>,
              // }}
              />
              <AddIcon className={styles.addIcon} title='Add ULD' onClick={props.onAddUld} disabled={Boolean(props.showReportModal) || props.isNoOp || cookies.get('role') === 'Airline Rep'} />
            </Stack>
            <div className={styles.tableWrapper}>
              <Box className={`${styles.tableOuter} ${buildupStyles.uldListTableOuter}`}>
                <StyledDataGrid
                  {...DataGridProps}
                  rows={props.ulds}
                  editMode='row'
                  columns={uldListColumns}
                  onRowClick={({ row }) => {
                    props.setActiveUld(row);
                  }}
                  rowModesModel={props.editMode}
                  processRowUpdate={props.handleRowEdit}
                  getRowClassName={({ row }) => props.editUldFields?.id === row?.id ? buildupStyles.selectedRow : ''}
                  param={props.ulds?.length}
                  classes={{
                    root: buildupStyles.uldListTable,
                    row: buildupStyles.uldListRow,
                    cell: buildupStyles.uldListCell,
                    columnHeaderTitleContainer: buildupStyles.columnHeaderTitleContainer,
                  }}
                  sx={{
                    '& .MuiDataGrid-row--editing': {
                      boxShadow: 'none',
                      '& .MuiDataGrid-cell': { backgroundColor: 'transparent', },
                      '& .MuiInputBase-root input': { padding: '0 8px', },
                    },
                  }}
                />
              </Box>
            </div>
          </StyledCard>
        </Grid>

        <Grid item container spacing={2} xs={12} sm={12} md={12} lg={12} xl={5}>
          <Grid item xs={12} sm={12} md={12} lg={7} xl={12} sx={{ minHeight: 'calc(100% - 44%)' }}>
            <StyledCard className={styles.h100}>
              <FlexDiv>
                <StyledCardTitle>ULD Contents {props.editUldFields?.uld_no && (`- ${props.editUldFields?.uld_no}`)}</StyledCardTitle>
              </FlexDiv>
              <Stack direction='row' alignItems={'center'} justifyContent='flex-end' mb={2} mt={'-16px'} spacing={2}>
                <CustomAutocomplete
                  popupIcon={
                    <IconButton
                      size='small'
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        // get value of input and pass to onSearch
                        const inputValue = e.target.closest('.MuiAutocomplete-root').querySelector('input').value;
                        props.onSearch(inputValue);
                      }}
                    >
                      <Search fontSize='inherit' />
                    </IconButton>
                  } 
                  inputValue={props.search?.awb_auto || ''}
                  onInputChange={(event, newInputValue) => {
                    props.handleAWBAutoComplete(newInputValue);
                  }}
                  options={(props.awbs || []).map(awb => ({
                    label: awb.code + '-' + awb.number,
                    value: awb.code + '-' + awb.number 
                  }))}
                  sx={{
                    width: 210,
                    '& .MuiAutocomplete-popupIndicatorOpen': { transform: 'none', },
                  }}
                  disabled={!props.editUldFields?.id || props.editUldFields?.closed || props.isNoOp || cookies.get('role') === 'Airline Rep'}
                  renderInput={(params) =>
                    <CustomTextField
                      {...InputProps}
                      {...params}
                      placeholder='Type to search AWB'
                      className={styles.brInput}
                    />}
                />
                <IconButton
                  size='small'
                  onClick={() => props.handleOpen('awb_info')}
                  title='AWB Info'
                  color='primary'
                >
                  <Stack direction='column' spacing={0} alignItems='center' justifyContent='center'>
                    <Typography color='inherit' component='span' className={buildupStyles.infoIcon}> i </Typography>
                    <Typography color='inherit' component='span' className={buildupStyles.awbInfoText}>AWB</Typography>
                  </Stack>
                </IconButton>
              </Stack>

              <div className={`${styles.tableWrapper} ${buildupStyles.containerEnd}`}>
                <Box className={`${styles.tableOuter} ${buildupStyles.uldContentTableOuter}`}>
                  <TableWrapper columns={uldContentColumns} data={props.editUldFields?.buildup_awb || []} />
                </Box>
              </div>
              <Grid container pl={0.5} mt={'auto'} rowSpacing={2} columnSpacing={3}>
                <Grid item xs={12} sm={3} md={3} lg={2}>
                  <Typography variant='body2' fontWeight={700} color={'primary'}>Totals:</Typography>
                </Grid>
                <Grid item xs={4} sm={3} md={3} lg={2}>
                  <Typography variant='body2' fontWeight={700} color={'primary'}>{props.editUldFields?.buildup_awb?.length || 0} AWBS</Typography>
                </Grid>
                <Grid item xs={4} sm={3} md={3} lg={2}>
                  <Typography variant='body2' fontWeight={700} color={'primary'}>{props.editUldFields?.buildup_awb?.reduce((acc, curr) => parseInt(acc) + parseInt(curr.pcs), 0) || 0} PCS</Typography>
                </Grid>
                <Grid item xs={4} sm={3} md={3} lg={2}>
                  <Typography variant='body2' fontWeight={700} color={'primary'}>{props.editUldFields?.buildup_awb?.reduce((acc, curr) => parseFloat(acc) + parseFloat(curr.wgt), 0) || 0} K</Typography>
                </Grid>
              </Grid>
            </StyledCard>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={5} xl={12} sx={{ minHeight: '44%' }}>
            <StyledCard className={styles.h100}>
              <FlexDiv><StyledCardTitle gutterBottom>Finalize ULD</StyledCardTitle></FlexDiv>
              {/* <Stack direction={'row'} spacing={2} alignItems={'center'} justifyContent={'flex-end'}>
                  {props.error && (
                    <Typography color='error' variant='body2'>
                      {props.error}
                    </Typography>
                  )}
                  <Chip
                    icon={<Circle className={ buildupStyles.circleIcon} />}
                    label={
                      <span style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8 
                      }}>
                        {`Port ${props.isConnecting ? 'Connecting...' : props.isConnected ? 'Connected' : 'Disconnected'}`}
                        <Divider orientation='vertical' flexItem />
                      </span>
                    }
                    color={props.isConnecting ? 'default' : props.isConnected ? 'secondary' : 'error'}
                    variant='filled'
                    size='small'
                    onDelete={props.openPort}
                    deleteIcon={<Refresh />}
                    className={buildupStyles.portChip}
                  />
                </Stack> */}
              <Stack direction={'row'} spacing={2} alignItems={'center'} justifyContent={'flex-end'} mb={2} mt={'-24px'}>
                {props.error && (
                  <Typography color='error' variant='body2'>
                    {props.error}
                  </Typography>
                )}
                <IconButton
                  size='small'
                  onClick={(e) => props.handleOpen('port_monitor', e.currentTarget)}
                  title='Port Monitor'
                  color='primary'
                >
                  <Typography color='inherit' component='span' className={buildupStyles.infoIcon}> i </Typography>
                </IconButton>
                <Chip
                  icon={<Circle className={buildupStyles.circleIcon} />}
                  label={
                    <span style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8
                    }}>
                      {`Port ${props.isConnecting ? 'Connecting...' : props.connected ? 'Connected' : 'Disconnected'}`}
                      <Divider orientation='vertical' flexItem />
                    </span>
                  }
                  color={props.isConnecting ? 'default' : props.connected ? 'secondary' : 'error'}
                  variant='filled'
                  size='small'
                  onDelete={() => props.openPort(true)}
                  deleteIcon={<Refresh />}
                  className={buildupStyles.portChip}
                />
              </Stack>
              <Grid container spacing={2} alignItems='center'>
                <Grid item xs={12} sm={6} md={2} lg={6} xl={3} marginBottom={'auto'}>
                  <Stack direction='row' justifyContent={'space-between'} alignItems={'flex-end'} spacing={2}>
                    <CustomInputLabel htmlFor='uld_dest' aria-label='Enter Uld Dest' className={buildupStyles.lineHeight}>ULD Dest</CustomInputLabel>
                    <CustomCheckbox
                      control={
                        <Checkbox inputProps={{ 'aria-label': '', }}
                          name='tu'
                          disableRipple
                          className={`${styles.py0} ${styles.pl0}`}
                          onChange={props.onChangeEditUld}
                          checked={props.editUldFields?.tu || false}
                          value={props.editUldFields?.tu || false}
                        />
                      }
                      label='TU'
                      className={`${styles.mr0} ${styles.pb1}`}
                      classes={{ label: buildupStyles.lineHeight }}
                      disabled={!props.editUldFields?.id || props.editUldFields?.closed || props.showReportModal}

                    />
                  </Stack>
                  <CustomTextField
                    {...InputProps}
                    id='uld_dest'
                    fullWidth
                    disabled={!props.editUldFields?.id || props.editUldFields?.closed || props.showReportModal}
                    name='dest'
                    value={props.editUldFields?.dest || ''}
                    onChange={props.onChangeEditUld}
                    onBlur={props.onEditUld}
                    error={Boolean(props.editUldErrors?.dest)}
                    // helperText={props.editUldErrors?.dest}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2} lg={6} xl={3} marginBottom={'auto'}>
                  <CustomInputLabel htmlFor='contour' aria-label='Enter Contour'>Contour / Height</CustomInputLabel>
                  <CustomTextField
                    {...InputProps}
                    id='contour'
                    fullWidth
                    disabled={!props.editUldFields?.id || props.editUldFields?.closed || props.showReportModal}
                    name='contour'
                    value={props.editUldFields?.contour || ''}
                    onChange={props.onChangeEditUld}
                    onBlur={props.onEditUld}
                    error={Boolean(props.editUldErrors?.contour)}
                    // helperText={props.editUldErrors?.contour}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2} lg={6} xl={3} marginBottom={'auto'} alignSelf={'stretch'}>
                  <CustomInputLabel htmlFor='transfer_at' aria-label='Enter transfer at'>Transfer at</CustomInputLabel>
                  <CustomTextField
                    {...InputProps}
                    id='transfer_at'
                    fullWidth
                    name='transfer_at'
                    disabled={!props.editUldFields?.id || props.editUldFields?.closed || !props.editUldFields?.tu || props.showReportModal}
                    value={props.editUldFields?.transfer_at || ''}
                    onChange={props.onChangeEditUld}
                    onBlur={props.onEditUld}
                    error={Boolean(props.editUldErrors?.transfer_at)}
                    // helperText={props.editUldErrors?.transfer_at}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2} lg={6} xl={3} marginBottom={'auto'} alignSelf={'stretch'}>
                  <CustomInputLabel htmlFor='onward_flight' aria-label='Enter Onward Flight'>Onward Flight</CustomInputLabel>
                  <CustomTextField
                    {...InputProps}
                    id='onward_flight'
                    fullWidth
                    name='onward_flight'
                    disabled={!props.editUldFields?.id || props.editUldFields?.closed || !props.editUldFields?.tu || props.showReportModal}
                    value={props.editUldFields?.onward_flight || ''}
                    onChange={props.onChangeEditUld}
                    onBlur={props.onEditUld}
                    error={Boolean(props.editUldErrors?.onward_flight)}
                    // helperText={props.editUldErrors?.onward_flight}
                  />
                </Grid>
                {/* <Grid item xs={12} sm={6} md={2} lg={6} xl={2.4} marginBottom={'auto'} alignSelf={'stretch'}>
                  <CustomInputLabel htmlFor='dolly_tare' aria-label='Enter Dolly tare'>Dolly Tare</CustomInputLabel>
                  <CustomTextField
                    {...InputProps}
                    id='dolly_tare'
                    fullWidth
                    disabled={!props.editUldFields?.id || props.editUldFields?.closed}
                    name='dolly_tare'
                    value={props.editUldFields?.dolly_tare || ''}
                    onChange={props.onChangeEditUld}
                    onBlur={props.onEditUld}
                    error={Boolean(props.editUldErrors?.dolly_tare)}
                    // helperText={props.editUldErrors?.dolly_tare}
                  />
                </Grid> */}
                <Grid item xs={12} sm={6} md={2} lg={6} xl={3} marginBottom={'auto'} alignSelf={'stretch'}>
                  <CustomInputLabel htmlFor='dolly_tare' aria-label='Enter Dolly tare'>Dolly Tare</CustomInputLabel>
                  <Stack direction='row' spacing={0} alignItems={'flex-start'} justifyContent={'space-between'}>
                    <FormControl variant='standard' fullWidth>
                      <CustomAutocomplete
                        disablePortal
                        id='dolly_tare'
                        options={props.dollys}
                        getOptionLabel={(option) => option.prefix + option.number}
                        onChange={(e, value) => props.onChangeEditUld({
                          target: {
                            name: 'dolly_prefix',
                            value
                          }
                        })}
                        name='dolly_prefix'
                        filterOptions={(options, params) => {
                          console.log(options, params);
                          const filtered = options.filter(option => {
                            if (params.inputValue == option.number || !params.inputValue) {
                              return option;
                            }
                          });
                          return filtered;
                        }
                        }
                        value={props.editUldFields?.dolly_prefix ? props.dollys.find(dolly => dolly.prefix + '' + dolly.number === props.editUldFields?.dolly_prefix) : null}
                        renderInput={(params) =>
                          <CustomTextField
                            {...InputProps}
                            {...params}
                            placeholder='Dolly Tare'
                            error={Boolean(props.editUldErrors?.dolly_tare)} 
                          />}
                        className={buildupStyles.uldTagAuto}
                        classes={{
                          root: buildupStyles.uldTagAutoRoot,
                          input: buildupStyles.uldTagAutoInput
                        }}
                        fullWidth
                        slotProps={{ paper: { className: styles.selectPaperIp }, }}
                        disabled={!props.editUldFields?.id || props.editUldFields?.closed || props.showReportModal}
                      />
                      {/* <CustomFormHelperText>{props.editUldErrors?.dolly_tare}</CustomFormHelperText> */}
                      <CustomFormHelperText>{props.editUldFields?.dolly_prefix ? `Weight: ${props.dollys.find(dolly => dolly.prefix + '' + dolly.number === props.editUldFields?.dolly_prefix)?.wgt} K` : null}</CustomFormHelperText>
                    </FormControl>
                    <IconButton className={`${buildupStyles.scanIcon} ${styles.dFlex} ${styles.mt1}`}
                      size='small'
                      onClick={props.sendDolly}
                      color='primary'
                      disabled={!props.editUldFields?.id || props.editUldFields?.closed || props.showReportModal}
                      classes={{ disabled: styles.disabledImg }}
                    >
                      <img src={Lock} alt={'open uld'} width={12} />
                    </IconButton>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={2} lg={6} xl={3} marginBottom={'auto'} alignSelf={'stretch'}>
                  <CustomInputLabel htmlFor='wgt' aria-label='Enter scale wgt gross'>Scale Wgt Gross</CustomInputLabel>
                  <Stack direction='row' spacing={0} alignItems={'center'} justifyContent={'space-between'}>
                    <CustomTextField
                      {...InputProps}
                      id='scale_wgt'
                      fullWidth
                      // disabled={!props.editUldFields?.id || props.editUldFields?.closed || props.editUldFields?.lock}
                      disabled
                      name='scale_wgt'
                      value={props.editUldFields?.scale_wgt || ''}
                      onChange={props.onChangeEditUld}
                      onBlur={props.onEditUld}
                      error={Boolean(props.editUldErrors?.scale_wgt)}
                      // helperText={props.editUldErrors?.scale_wgt}
                    />
                    <IconButton className={`${buildupStyles.scanIcon} ${styles.dFlex} `}
                      onClick={() => props.onChangeEditUld({
                        target: {
                          name: 'lock',
                          value: props.editUldFields?.lock ? false : true
                        }
                      })}
                      size='small'
                      color='primary'
                      disabled={!props.editUldFields?.id || props.editUldFields?.closed || props.showReportModal}
                      classes={{ disabled: styles.disabledImg }}
                    >
                      {props.editUldFields?.lock ? <img src={Lock} alt={'open uld'} width={12} /> :
                        <img src={Unlock} alt={'close uld'} width={12} />}
                    </IconButton>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={2} lg={6} xl={3} marginBottom={'auto'}>
                  <CustomInputLabel htmlFor='uld_wgt' aria-label='Enter uld wgt'>ULD Wgt</CustomInputLabel>
                  <CustomTextField
                    {...InputProps}
                    id='wgt'
                    fullWidth
                    disabled={!props.editUldFields?.id || !props.editUldFields?.add_wgt || props.editUldFields?.closed || !canEditWgt || props.showReportModal}
                    name='wgt'
                    value={props.editUldFields?.wgt || (props.editUldFields?.scale_wgt || 0) - (props.editUldFields?.dolly_tare || 0)}
                    onChange={props.onChangeEditUld}
                    onBlur={props.onEditUld}
                    InputProps={{
                      disableUnderline: true,
                      endAdornment: <InputAdornment position='end'>
                        <IconButton className={`${styles.actionIcons} ${styles.mr2}`}
                          onClick={() => props.onChangeEditUld({
                            target: {
                              name: 'add_wgt',
                              value: !props.editUldFields?.add_wgt
                            }
                          })}
                          disabled={props.showReportModal}
                          classes={{ disabled: styles.disabledImg }}
                        ><EditIcon /></IconButton>
                      </InputAdornment>,
                    }}
                    error={Boolean(props.editUldErrors?.wgt)}
                    // helperText={props.editUldErrors?.wgt}
                  />
                  {
                    props.editUldFields?.edited_by &&
                    <CustomFormHelperText className={buildupStyles.helperText}>Edited By: {props.editUldFields?.edited_by ? props.editUldFields?.edited_by?.first_name + ' ' + props.editUldFields?.edited_by?.last_name : ''}</CustomFormHelperText>
                  }
                </Grid>
                <Grid item xs={12} sm={6} md={2} lg={6} xl marginBottom={'auto'}>
                  <CustomInputLabel htmlFor='content' aria-label='Enter Content'>Contents</CustomInputLabel>
                  <CustomSelect
                    {...SelectInputProps}
                    id='content'
                    labelId='content-label'
                    fullWidth
                    autoFocus
                    onChange={props.onChangeEditUld}
                    name='contents'
                    disabled={!props.editUldFields?.id || props.editUldFields?.closed || props.showReportModal}
                    value={!props?.editUldFields?.contents ? false : props.editUldFields.contents}
                  >
                    <MenuItem value='placeholder' disabled >Select Content</MenuItem>
                    {['c', 'cw', 'e', 'm', 'u', 'w', 'x'].map((code) => (
                      <MenuItem key={code} value={code.toUpperCase()}>{code.toUpperCase()}</MenuItem>
                    ))}
                  </CustomSelect>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={12} xl={7} marginBottom={'auto'}>
                  <Stack direction='row' justifyContent={'space-between'} alignItems={'flex-end'} spacing={2}>
                    <CustomInputLabel htmlFor='specials' aria-label='Enter specials' className={buildupStyles.lineHeight}>Specials/Remarks</CustomInputLabel>
                    <CustomCheckbox
                      control={
                        <Checkbox inputProps={{ 'aria-label': '', }}
                          name='dangerous'
                          disableRipple
                          className={`${styles.py0} ${styles.pl0}`}
                          onChange={props.onChangeEditUld}
                          checked={props.editUldFields?.dangerous || false}
                          value={props.editUldFields?.dangerous || false}
                        />
                      }
                      label='Contains Dangerous Goods'
                      className={`${styles.mr0} ${styles.pb1}`}
                      classes={{ label: buildupStyles.lineHeight }}
                      disabled={!props.editUldFields?.id || props.editUldFields?.closed || props.showReportModal}
                    />
                  </Stack>
                  <CustomTextField
                    {...InputProps}
                    id='remark'
                    fullWidth
                    disabled={!props.editUldFields?.id || props.editUldFields?.closed || props.showReportModal}
                    name='remark'
                    value={props.editUldFields?.remark || ''}
                    inputProps={{ maxLength: CHARACTER_LIMIT }}
                    helperText={props.editUldFields?.remark?.length > 0 && `${(CHARACTER_LIMIT - props.editUldFields?.remark?.length)} characters remaining`}
                    onChange={props.onChangeEditUld}
                    onBlur={props.onEditUld}
                    sx={{
                      '& .MuiFormHelperText-root': {
                        textAlign: 'right',
                        right: 0
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md marginTop={3}>
                  <Stack direction='row' spacing={3} justifyContent='flex-end'>
                    <TableBadge color='error' badgeContent={props.editUldFields?.uld_loadingaccessories?.filter((a) => a.value).length}>
                      <CustomButton startIcon={<FormatListBulleted fontSize='1.7rem' />}
                        disableRipple
                        title='Loading Accessories Used'
                        classes={{ startIcon: styles.mauto }}
                        onClick={(e) => props.handleOpen('loading_accesories', e.currentTarget)}
                        disabled={!props.editUldFields?.id || props.showReportModal}
                        variant='contained'
                        color='primary'
                        className={buildupStyles.tagBtn} />
                    </TableBadge>
                    {!props.editUldFields?.closed &&
                      <CustomButton startIcon={
                        <img src={Unlock} alt={'close uld'} width={15} className={styles.whiteSvg} />}
                      disableRipple
                      title='Close ULD'
                      classes={{
                        startIcon: styles.mauto,
                        disabled: styles.disabledIconImg
                      }}
                      onClick={() => props.onChangeEditUld({
                        target: {
                          name: 'closed',
                          value: true
                        }
                      })}
                      disabled={!props.editUldFields?.id || props.showReportModal}
                      variant='contained'
                      color='primary'
                      className={buildupStyles.tagBtn} />
                    }
                    {props.editUldFields?.closed &&
                      <CustomButton startIcon={
                        <img src={Lock} alt={'open uld'} width={15} className={styles.whiteSvg} />}
                      disableRipple
                      title='Open ULD'
                      classes={{
                        startIcon: styles.mauto,
                        disabled: styles.disabledIconImg
                      }}
                      onClick={() => props.onChangeEditUld({
                        target: {
                          name: 'closed',
                          value: false
                        }
                      })}
                      disabled={!props.editUldFields?.id || props.showReportModal}
                      variant='contained'
                      color='primary'
                      className={buildupStyles.tagBtn} />
                    }
                    <CustomButton title='Print ULD Tag' disabled={!props.editUldFields?.id || props.showReportModal} variant='contained' size='small' color='primary' onClick={props.onTag} className={buildupStyles.tagBtn}>
                      TAG
                    </CustomButton>
                    <CustomButton startIcon={<Balance />}
                      disableRipple
                      title='Print'
                      classes={{
                        startIcon: `${styles.mxauto} ${buildupStyles.balanceIcon}`,
                        disabled: styles.disabledIconImg
                      }}
                      variant='contained'
                      color='primary'
                      onClick={() => props.writeToSerialPort('print')}
                      className={`${buildupStyles.tagBtn} ${buildupStyles.printBtn}`} >
                      <span className={buildupStyles.printBtnText}>Print</span>
                    </CustomButton>
                  </Stack>
                </Grid>
              </Grid>
            </StyledCard>
          </Grid>
        </Grid>
      </Grid>

      {props.modal === 'awb_details' &&
        <AwbDetailModal
          modal={props.modal}
          onClose={props.handleClose}
          searchAwb={props.searchAwb}
          awbFields={props.awbFields}
          onChangeAwb={props.onChangeAwb}
          onLoadAwb={props.onLoadAwb}
          onChnageSearchAwb={props.onChnageSearchAwb}
          onSaveSearchAwb={props.onSaveSearchAwb}
          handleDelete={props.handleDelete}
          editLoadAwb={props.editLoadAwb}
          onLoadEditAwb={props.onLoadEditAwb}
          onChangeLoadAwb={props.onChangeLoadAwb}
          onSaveLoadAwb={props.onSaveLoadAwb}
          uldNo={props.editUldFields?.uld_no}
          showReportModal={props.showReportModal}
        />
      }

      {
        props.modal === 'history' &&
        <History
          popover={props.modal}
          anchorEl={props.anchorEl}
          onClose={props.handleClose}
          data={props.history}
          accessories={props.accessories}
        />
      }

      {props.modal === 'move_uld_to_diff_flight' &&
        <MoveUldToDiffFlight
          popover={props.modal}
          anchorEl={props.anchorEl}
          onClose={props.handleClose}
          uld={props.editUldFields}
          flight={props.flight}
          flights={props.flights}
          airlines={props.airlines}
          flightFields={props.flightFields}
          onChangeFlight={props.onChangeFlight}
          onSaveFlight={props.onSaveFlight}
          showReportModal={props.showReportModal}
        />
      }

      {<Status
        statusModal={props.wgtError}
        onClose={props.hideWgtError}
        statusMessage={{
          type: 'warning',
          size: 'sm',
          title: 'Warning',
          mainMessage: 'Please Change the Scale Unit to KG!',
          firstMessage: 'The current unit is incorrect. Switch to kilograms (KG) to proceed.',
          secondMessage: ''
        }}
      />}

      <Popover
        open={props.modal === 'loading_accesories'}
        anchorEl={props.anchorEl}
        onClose={props.handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        slotProps={{ paper: { className: buildupStyles.loadAccessoriesPopover, } }}
      >
        <Typography variant='body1' color='primary' px={3} py={2} fontWeight={600}>Loading Accessories Used</Typography>
        <CloseIconBtn onClick={props.handleClose} />
        <Divider />

        <Grid container spacing={2} px={3} py={2}>
          {props.accessories.map((a, index, self) => (
            <Grid item key={index} xs={6} className={(self.length === 1) || (index % 2) ? '' : buildupStyles.accRowOdd}>
              <Stack direction={'row'} justifyContent={'space-between'} spacing={2}>
                <Typography variant='caption' maxWidth={'150px'}>{a.description}</Typography>
                <TextField
                  variant='outlined'
                  id='spreader_boards'
                  defaultValue={props.editUldFields?.uld_loadingaccessories?.find(b => b.loadingaccessoriesId === a.id)?.value || ''}
                  name={a.id}
                  className={buildupStyles.tableTextField}
                  onBlur={props.onChangeAccessories}
                />
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Popover>

      <Popover
        open={props.modal === 'port_monitor'}
        anchorEl={props.anchorEl}
        onClose={props.handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        slotProps={{ paper: { className: buildupStyles.portMonitorPopover, } }}
      >
        <Typography variant='body1' color='primary' px={3} py={2} fontWeight={600}>Port Monitor</Typography>
        <CloseIconBtn onClick={props.handleClose} />
        <Divider />
        <Typography variant='body2' px={3} py={2}>{props.render_txt ? props.render_txt : 'No data to display'}</Typography>
      </Popover>
      {
        (props.modal === 'remark') &&
        <RemarkModal
          modal={props.modal}
          onClose={props.handleClose}
          remark={props.anchorEl}
        />
      }
      {props.modal === 'awb_info' &&
        <AwbInfoModal
          selected_AwbId ={props.selected_AwbId}
          onChnageSelectAwb={props.onChnageSelectAwb}
          onSearch={props.onSearch}
          modal={props.modal}
          awbs={props.awbs}
          onClose={props.handleClose}
          disableMoveToUld={!props.editUldFields?.id || props.editUldFields?.closed || props.isNoOp || cookies.get('role') === 'Airline Rep'}
        />
      }
    </>
  );
};

export default Buildup;

